<template>
    <div class="content_box mobile_content">
        <div class="content role">
            <div class="title_box">
                <span class="title">APP 升级配置管理</span>
            </div>
            <div class="btn_box">
                <div class="button button2 add" @click="addSettings" v-if="roleCheck('103-102-103-102')">
                    <i class="el-icon-plus"></i>
                    <span>新建</span>
                </div>
            </div>
            
            <el-table
                highlight-current-row
                :data="listData"
                style="width: 100%">
                <el-table-column prop="app_version" label="版本号" ></el-table-column>
                <el-table-column label="强制升级" width="100px">
                    <template slot-scope="scope" >
                        <span class="state state2" v-if="scope.row.is_forced == 0">否</span>
                        <span class="state state1" v-else-if="scope.row.is_forced == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="client_sys" label="客户端" ></el-table-column>
                <el-table-column prop="title" label="标题" ></el-table-column>
                <el-table-column prop="content" label="内容" >
                    <template slot-scope="scope" >
                        <p class="update_content" :title="scope.row.content" v-html="scope.row.content"></p>
                    </template>
                </el-table-column>
                <el-table-column prop="group_name" label="群组"></el-table-column>
                <el-table-column label="创建时间" width="160px">
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.update_time)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope" >
                        <div>
                            <div class="button text" @click="updateSettings(scope.row)" v-if="roleCheck('103-102-103-102')">编辑</div>
                            <div class="button text del_btn"  @click="delList(scope.row)" v-if="roleCheck('103-102-103-103')">删除</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination> -->
            <Tip ref="tip" :msg="`确定删除 ${actData.client_sys} ${actData.app_version} 数据？`">
                <template v-slot:confirm_btn>
                    <div class="button del" @click="deleteConfirm">
                        <span>确认</span>
                    </div>
                </template>
            </Tip>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                        <el-form-item label="客户端" prop="client_sys">
                            <el-radio-group v-model="actData.client_sys">
                                <el-radio label="ios">iOS</el-radio>
                                <el-radio label="android">Android</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="版本号" prop="app_version">
                            <el-input v-model="actData.app_version" placeholder="请输入Build Number"></el-input>
                        </el-form-item>
                        <el-form-item label="强制更新" prop="is_forced">
                            <el-radio-group v-model="actData.is_forced">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="actData.title" maxlength="8" placeholder="请输入标题"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="content">
                            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" maxlength="200" show-word-limit  v-model="actData.content" placeholder="请输入更新内容"></el-input>
                        </el-form-item>
                        <el-form-item label="群组">
                            <el-select v-model="groupList" multiple placeholder="请选择群组">
                                <el-option :label="item.group_name" :value="item.id" v-for="(item, i) in group" :key="i + '433656'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default({
    name: 'app-update-settings',
    data() {
        return {
            searchData: {
                
            },
            listData: [],
            total: 0,
            group: [],
            groupList: [],
            dislog: {
                type: '',
                title: ''
            },
            actData: {},
            formRule: {
                client_sys: [this.requiredRule('请输入名称')],
                title: [this.requiredRule('请输入标题')],
                content: [this.requiredRule('请输入更新内容')],
            },
        }
    },
    created() {
        this.getList();
        this.getGroupList();
    },
    methods: {
        addSettings() {
            this.dislog = {
                type: 'add',
                title: '新增APP更新配置'
            };
            this.actData = {
                client_sys: 'ios',
                is_forced: 0
            };
            this.groupList = [];
            this.$refs.dislog.show = true;
        },
        getGroupList() {
            this.api.getGroupList({}).then(data => {
                this.group = data.data.result;
            })
        },
        getList() {
            this.api.getAppUpdateSettings(this.searchData).then(data => {
                this.listData = data.data || [];
                // this.total = data.data.total || 0;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        updateSettings(item) {
            this.dislog = {
                type: 'update',
                title: '编辑APP更新配置'
            };
            this.actData = {...item};
            delete this.actData.group_name;
            delete this.actData.create_time;
            this.groupList = item.group_list ? item.group_list.split(';').map(Number) : '';
            this.$refs.dislog.show = true;
        },
        updateConfirm() {
            this.$refs.formRule.validate(v => {
                if(v) {
                    this.actData.group_list = this.groupList.join(';');
                    this.api.appUpdateSettings(this.actData).then(data => {
                        this.$message.success('操作成功！');
                        this.getList();
                        this.$refs.dislog.show = false;
                    })
                }
            })
            
        },
        delList(item) {
            this.actData = {...item};
            this.$refs.tip.show = true;
        },
        deleteConfirm() {
            this.api.delAppUpdateSettings({id: this.actData.id}).then(data => {
                this.$message.success('操作成功！');
                this.getList();
                this.$refs.tip.show = false;
            })
        }
    }
})
</script>
<style lang="less" scoped>
   
    .update_content{
        white-space: pre-wrap;
    }
    
</style>



// WEBPACK FOOTER //
// src/view/app/market-manage/update-settings.vue